webpackJsonp(["boards"],{

/***/ "../../../node_modules/vue-loader/lib/component-normalizer.js":
/***/ (function(module, exports) {

// this module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle

module.exports = function normalizeComponent (
  rawScriptExports,
  compiledTemplate,
  scopeId,
  cssModules
) {
  var esModule
  var scriptExports = rawScriptExports = rawScriptExports || {}

  // ES6 modules interop
  var type = typeof rawScriptExports.default
  if (type === 'object' || type === 'function') {
    esModule = rawScriptExports
    scriptExports = rawScriptExports.default
  }

  // Vue.extend constructor export interop
  var options = typeof scriptExports === 'function'
    ? scriptExports.options
    : scriptExports

  // render functions
  if (compiledTemplate) {
    options.render = compiledTemplate.render
    options.staticRenderFns = compiledTemplate.staticRenderFns
  }

  // scopedId
  if (scopeId) {
    options._scopeId = scopeId
  }

  // inject cssModules
  if (cssModules) {
    var computed = Object.create(options.computed || null)
    Object.keys(cssModules).forEach(function (key) {
      var module = cssModules[key]
      computed[key] = function () { return module }
    })
    options.computed = computed
  }

  return {
    esModule: esModule,
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ "../images/no_avatar.png":
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEsAAABLCAAAAAAdJSU2AAACNElEQVR4AdXYBa7jMBCA4b3/JZahzIkjp2qt+BWUWnG5ln2XxaJJb2b5F2ukL4wvzK/rP7bUcbf92u6oftLSe1ldk8efsfaVeEjusZZeC6e1RllaCk/yG6ag1lZ4WwPX69uyD6tAe/g2ipAlNMRS37awDLaFrpcMWxXQOi0jnWCWjFkSZomYJWDWKmatYNZyEWkJsvQimoZYah5NgdaLxagCtF6GRy0DshZPkeYwS/KIJWGWYjwYUzDLxCwDtJ54OKglimBLqHWahii2g1pmHLLGBmwVoRjcKlmgOdw65H5qKuGWCVi5Qlhs6m1sENZi4q3AWNvca5UYy2RjT/SAsiZey6CsIvc0wVlV5lJ0ibPMyLUGCmlxQq0IM0hLdWyro7CWEc3sXsqaK4O2zLxOsmtpfW5Q1u68ZrVmepaaNXEewawtI9X5Xl3U3n1qND6+rfPzvqoIWz/fklNCSLY153YV53J/XUxGCJnKZ1lajsn3/Ffegf6Y5pV2LUsSNL2UHzxUfh3TlYpZqqTpXZm0KZk9zJcqaEmaWPHDw0pxe05K7bWOLHFLWXVetqpYmrjle4+1y0aBaF4UOQ1NU+lYezJClkjLUnSEjqhH6zjAW4OjtY39Ibq+sawUb6W2RQfoqG0VeKuwrRJvlba17faRdbe2pTtYq6Nty/S7yAbGsQjWIq41wVoT1+IdZNy1djUcVdu5lklQWC0xHkt1X31qNEE1Pr3qKv/9XiSNj6Aaifj3/69+AYujsR/MvkpZAAAAAElFTkSuQmCC"

/***/ }),

/***/ "./boards/boards_bundle.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_resource__ = __webpack_require__("../../../node_modules/vue-resource/dist/vue-resource.es2015.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__filtered_search_boards__ = __webpack_require__("./boards/filtered_search_boards.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__eventhub__ = __webpack_require__("./boards/eventhub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__models_issue__ = __webpack_require__("./boards/models/issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_label__ = __webpack_require__("./boards/models/label.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__models_label___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__models_label__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__models_list__ = __webpack_require__("./boards/models/list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_milestone__ = __webpack_require__("./boards/models/milestone.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__models_milestone___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__models_milestone__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_assignee__ = __webpack_require__("./boards/models/assignee.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__models_assignee___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__models_assignee__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__stores_boards_store__ = __webpack_require__("./boards/stores/boards_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stores_modal_store__ = __webpack_require__("./boards/stores/modal_store.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__stores_modal_store___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__stores_modal_store__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__services_board_service__ = __webpack_require__("./boards/services/board_service.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_modal_mixins__ = __webpack_require__("./boards/mixins/modal_mixins.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__mixins_modal_mixins___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__mixins_modal_mixins__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_sortable_default_options__ = __webpack_require__("./boards/mixins/sortable_default_options.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__mixins_sortable_default_options___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__mixins_sortable_default_options__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__filters_due_date_filters__ = __webpack_require__("./boards/filters/due_date_filters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_board__ = __webpack_require__("./boards/components/board.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_board_sidebar__ = __webpack_require__("./boards/components/board_sidebar.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_new_list_dropdown__ = __webpack_require__("./boards/components/new_list_dropdown.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_modal_index__ = __webpack_require__("./boards/components/modal/index.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__vue_shared_vue_resource_interceptor__ = __webpack_require__("./vue_shared/vue_resource_interceptor.js");
/* eslint-disable one-var, quote-props, comma-dangle, space-before-function-paren */
/* global BoardService */
/* global Flash */























__WEBPACK_IMPORTED_MODULE_1_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_2_vue_resource__["a" /* default */]);

$(function () {
  var $boardApp = document.getElementById('board-app');
  var Store = gl.issueBoards.BoardsStore;
  var ModalStore = gl.issueBoards.ModalStore;

  window.gl = window.gl || {};

  if (gl.IssueBoardsApp) {
    gl.IssueBoardsApp.$destroy(true);
  }

  Store.create();

  // hack to allow sidebar scripts like milestone_select manipulate the BoardsStore
  gl.issueBoards.boardStoreIssueSet = function () {
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].set.apply(__WEBPACK_IMPORTED_MODULE_1_vue__["default"], [Store.detail.issue].concat(args));
  };
  gl.issueBoards.boardStoreIssueDelete = function () {
    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    return __WEBPACK_IMPORTED_MODULE_1_vue__["default"].delete.apply(__WEBPACK_IMPORTED_MODULE_1_vue__["default"], [Store.detail.issue].concat(args));
  };

  gl.IssueBoardsApp = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: $boardApp,
    components: {
      'board': gl.issueBoards.Board,
      'board-sidebar': gl.issueBoards.BoardSidebar,
      'board-add-issues-modal': gl.issueBoards.IssuesModal
    },
    data: {
      state: Store.state,
      loading: true,
      endpoint: $boardApp.dataset.endpoint,
      boardId: $boardApp.dataset.boardId,
      disabled: $boardApp.dataset.disabled === 'true',
      issueLinkBase: $boardApp.dataset.issueLinkBase,
      rootPath: $boardApp.dataset.rootPath,
      bulkUpdatePath: $boardApp.dataset.bulkUpdatePath,
      detailIssue: Store.detail,
      defaultAvatar: $boardApp.dataset.defaultAvatar
    },
    computed: {
      detailIssueVisible: function detailIssueVisible() {
        return Object.keys(this.detailIssue.issue).length;
      }
    },
    created: function created() {
      gl.boardService = new BoardService(this.endpoint, this.bulkUpdatePath, this.boardId);

      this.filterManager = new __WEBPACK_IMPORTED_MODULE_3__filtered_search_boards__["a" /* default */](Store.filter, true);
      this.filterManager.setup();

      // Listen for updateTokens event
      __WEBPACK_IMPORTED_MODULE_4__eventhub__["a" /* default */].$on('updateTokens', this.updateTokens);
    },
    beforeDestroy: function beforeDestroy() {
      __WEBPACK_IMPORTED_MODULE_4__eventhub__["a" /* default */].$off('updateTokens', this.updateTokens);
    },
    mounted: function mounted() {
      var _this = this;

      Store.disabled = this.disabled;
      gl.boardService.all().then(function (response) {
        return response.json();
      }).then(function (resp) {
        resp.forEach(function (board) {
          var list = Store.addList(board, _this.defaultAvatar);

          if (list.type === 'closed') {
            list.position = Infinity;
            list.label = { description: 'Shows all closed issues. Moving an issue to this list closes it' };
          } else if (list.type === 'backlog') {
            list.position = -1;
          }
        });

        _this.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(_this.state.lists, 'position');

        Store.addBlankState();
        _this.loading = false;
      }).catch(function () {
        return new Flash('An error occurred. Please try again.');
      });
    },

    methods: {
      updateTokens: function updateTokens() {
        this.filterManager.updateTokens();
      }
    }
  });

  gl.IssueBoardsSearch = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    el: document.getElementById('js-add-list'),
    data: {
      filters: Store.state.filters
    },
    mounted: function mounted() {
      gl.issueBoards.newListDropdownInit();
    }
  });

  gl.IssueBoardsModalAddBtn = new __WEBPACK_IMPORTED_MODULE_1_vue__["default"]({
    mixins: [gl.issueBoards.ModalMixins],
    el: document.getElementById('js-add-issues-btn'),
    data: {
      modal: ModalStore.store,
      store: Store.state
    },
    watch: {
      disabled: function disabled() {
        this.updateTooltip();
      }
    },
    computed: {
      disabled: function disabled() {
        return !this.store.lists.filter(function (list) {
          return !list.preset;
        }).length;
      },
      tooltipTitle: function tooltipTitle() {
        if (this.disabled) {
          return 'Please add a list to your board first';
        }

        return '';
      }
    },
    methods: {
      updateTooltip: function updateTooltip() {
        var _this2 = this;

        var $tooltip = $(this.$el);

        this.$nextTick(function () {
          if (_this2.disabled) {
            $tooltip.tooltip();
          } else {
            $tooltip.tooltip('destroy');
          }
        });
      },
      openModal: function openModal() {
        if (!this.disabled) {
          this.toggleModal(true);
        }
      }
    },
    mounted: function mounted() {
      this.updateTooltip();
    },

    template: '\n      <button\n        class="btn btn-create pull-right prepend-left-10"\n        type="button"\n        data-placement="bottom"\n        :class="{ \'disabled\': disabled }"\n        :title="tooltipTitle"\n        :aria-disabled="disabled"\n        @click="openModal">\n        Add issues\n      </button>\n    '
  });
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/board.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lib_utils_accessor__ = __webpack_require__("./lib/utils/accessor.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__board_list__ = __webpack_require__("./boards/components/board_list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__board_blank_state__ = __webpack_require__("./boards/components/board_blank_state.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__board_delete__ = __webpack_require__("./boards/components/board_delete.js");
/* eslint-disable comma-dangle, space-before-function-paren, one-var */
/* global Sortable */






var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.Board = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  template: '#js-board-template',
  components: {
    boardList: __WEBPACK_IMPORTED_MODULE_2__board_list__["a" /* default */],
    'board-delete': gl.issueBoards.BoardDelete,
    boardBlankState: __WEBPACK_IMPORTED_MODULE_3__board_blank_state__["a" /* default */]
  },
  props: {
    list: Object,
    disabled: Boolean,
    issueLinkBase: String,
    rootPath: String,
    boardId: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      detailIssue: Store.detail,
      filter: Store.filter
    };
  },

  watch: {
    filter: {
      handler: function handler() {
        this.list.page = 1;
        this.list.getIssues(true).catch(function () {
          // TODO: handle request error
        });
      },

      deep: true
    },
    detailIssue: {
      handler: function handler() {
        if (!Object.keys(this.detailIssue.issue).length) return;

        var issue = this.list.findIssue(this.detailIssue.issue.id);

        if (issue) {
          var offsetLeft = this.$el.offsetLeft;
          var boardsList = document.querySelectorAll('.boards-list')[0];
          var left = boardsList.scrollLeft - offsetLeft;
          var right = offsetLeft + this.$el.offsetWidth;

          if (window.innerWidth > 768 && boardsList.classList.contains('is-compact')) {
            // -290 here because width of boardsList is animating so therefore
            // getting the width here is incorrect
            // 290 is the width of the sidebar
            right -= boardsList.offsetWidth - 290;
          } else {
            right -= boardsList.offsetWidth;
          }

          if (right - boardsList.scrollLeft > 0) {
            $(boardsList).animate({
              scrollLeft: right
            }, this.sortableOptions.animation);
          } else if (left > 0) {
            $(boardsList).animate({
              scrollLeft: offsetLeft
            }, this.sortableOptions.animation);
          }
        }
      },

      deep: true
    }
  },
  methods: {
    showNewIssueForm: function showNewIssueForm() {
      this.$refs['board-list'].showIssueForm = !this.$refs['board-list'].showIssueForm;
    },
    toggleExpanded: function toggleExpanded(e) {
      if (this.list.isExpandable && !e.target.classList.contains('js-no-trigger-collapse')) {
        this.list.isExpanded = !this.list.isExpanded;

        if (__WEBPACK_IMPORTED_MODULE_1__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe()) {
          localStorage.setItem('boards.' + this.boardId + '.' + this.list.type + '.expanded', this.list.isExpanded);
        }
      }
    }
  },
  mounted: function mounted() {
    var _this = this;

    this.sortableOptions = gl.issueBoards.getBoardSortableDefaultOptions({
      disabled: this.disabled,
      group: 'boards',
      draggable: '.is-draggable',
      handle: '.js-board-handle',
      onEnd: function onEnd(e) {
        gl.issueBoards.onEnd();

        if (e.newIndex !== undefined && e.oldIndex !== e.newIndex) {
          var order = _this.sortable.toArray();
          var list = Store.findList('id', parseInt(e.item.dataset.id, 10));

          _this.$nextTick(function () {
            Store.moveList(list, order);
          });
        }
      }
    });

    this.sortable = Sortable.create(this.$el.parentNode, this.sortableOptions);
  },
  created: function created() {
    if (this.list.isExpandable && __WEBPACK_IMPORTED_MODULE_1__lib_utils_accessor__["a" /* default */].isLocalStorageAccessSafe()) {
      var isCollapsed = localStorage.getItem('boards.' + this.boardId + '.' + this.list.type + '.expanded') === 'false';

      this.list.isExpanded = !isCollapsed;
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/board_blank_state.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* global ListLabel */




var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  template: '\n    <div class="board-blank-state">\n      <p>\n        Add the following default lists to your Issue Board with one click:\n      </p>\n      <ul class="board-blank-state-list">\n        <li v-for="label in predefinedLabels">\n          <span\n            class="label-color"\n            :style="{ backgroundColor: label.color }">\n          </span>\n          {{ label.title }}\n        </li>\n      </ul>\n      <p>\n        Starting out with the default set of lists will get you right on the way to making the most of your board.\n      </p>\n      <button\n        class="btn btn-create btn-inverted btn-block"\n        type="button"\n        @click.stop="addDefaultLists">\n        Add default lists\n      </button>\n      <button\n        class="btn btn-default btn-block"\n        type="button"\n        @click.stop="clearBlankState">\n        Nevermind, I\'ll use my own\n      </button>\n    </div>\n  ',
  data: function data() {
    return {
      predefinedLabels: [new ListLabel({ title: 'To Do', color: '#F0AD4E' }), new ListLabel({ title: 'Doing', color: '#5CB85C' })]
    };
  },

  methods: {
    addDefaultLists: function addDefaultLists() {
      this.clearBlankState();

      this.predefinedLabels.forEach(function (label, i) {
        Store.addList({
          title: label.title,
          position: i,
          list_type: 'label',
          label: {
            title: label.title,
            color: label.color
          }
        });
      });

      Store.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(Store.state.lists, 'position');

      // Save the labels
      gl.boardService.generateDefaultLists().then(function (resp) {
        return resp.json();
      }).then(function (data) {
        data.forEach(function (listObj) {
          var list = Store.findList('title', listObj.title);

          list.id = listObj.id;
          list.label.id = listObj.label.id;
          list.getIssues().catch(function () {
            // TODO: handle request error
          });
        });
      }).catch(function () {
        Store.removeList(undefined, 'label');
        __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.remove('issue_board_welcome_hidden', {
          path: ''
        });
        Store.addBlankState();
      });
    },

    clearBlankState: Store.removeBlankState.bind(Store)
  }
});

/***/ }),

/***/ "./boards/components/board_card.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__issue_card_inner__ = __webpack_require__("./boards/components/issue_card_inner.js");


var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardsIssueCard',
  template: '\n    <li class="card"\n      :class="{ \'user-can-drag\': !disabled && issue.id, \'is-disabled\': disabled || !issue.id, \'is-active\': issueDetailVisible }"\n      :index="index"\n      :data-issue-id="issue.id"\n      @mousedown="mouseDown"\n      @mousemove="mouseMove"\n      @mouseup="showIssue($event)">\n      <issue-card-inner\n        :list="list"\n        :issue="issue"\n        :issue-link-base="issueLinkBase"\n        :root-path="rootPath"\n        :update-filters="true" />\n    </li>\n  ',
  components: {
    'issue-card-inner': gl.issueBoards.IssueCardInner
  },
  props: {
    list: Object,
    issue: Object,
    issueLinkBase: String,
    disabled: Boolean,
    index: Number,
    rootPath: String
  },
  data: function data() {
    return {
      showDetail: false,
      detailIssue: Store.detail
    };
  },

  computed: {
    issueDetailVisible: function issueDetailVisible() {
      return this.detailIssue.issue && this.detailIssue.issue.id === this.issue.id;
    }
  },
  methods: {
    mouseDown: function mouseDown() {
      this.showDetail = true;
    },
    mouseMove: function mouseMove() {
      this.showDetail = false;
    },
    showIssue: function showIssue(e) {
      if (e.target.classList.contains('js-no-trigger')) return;

      if (this.showDetail) {
        this.showDetail = false;

        if (Store.detail.issue && Store.detail.issue.id === this.issue.id) {
          Store.detail.issue = {};
        } else {
          Store.detail.issue = this.issue;
          Store.detail.list = this.list;
        }
      }
    }
  }
});

/***/ }),

/***/ "./boards/components/board_delete.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable comma-dangle, space-before-function-paren, no-alert */



window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardDelete = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    list: Object
  },
  methods: {
    deleteBoard: function deleteBoard() {
      $(this.$el).tooltip('hide');

      if (confirm('Are you sure you want to delete this list?')) {
        this.list.destroy();
      }
    }
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/board_list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__board_new_issue__ = __webpack_require__("./boards/components/board_new_issue.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__board_card__ = __webpack_require__("./boards/components/board_card.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventhub__ = __webpack_require__("./boards/eventhub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue__);
/* global Sortable */





var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardList',
  props: {
    disabled: {
      type: Boolean,
      required: true
    },
    list: {
      type: Object,
      required: true
    },
    issues: {
      type: Array,
      required: true
    },
    loading: {
      type: Boolean,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return {
      scrollOffset: 250,
      filters: Store.state.filters,
      showCount: false,
      showIssueForm: false
    };
  },

  components: {
    boardCard: __WEBPACK_IMPORTED_MODULE_1__board_card__["a" /* default */],
    boardNewIssue: __WEBPACK_IMPORTED_MODULE_0__board_new_issue__["a" /* default */],
    loadingIcon: __WEBPACK_IMPORTED_MODULE_3__vue_shared_components_loading_icon_vue___default.a
  },
  methods: {
    listHeight: function listHeight() {
      return this.$refs.list.getBoundingClientRect().height;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.list.scrollHeight;
    },
    scrollTop: function scrollTop() {
      return this.$refs.list.scrollTop + this.listHeight();
    },
    scrollToTop: function scrollToTop() {
      this.$refs.list.scrollTop = 0;
    },
    loadNextPage: function loadNextPage() {
      var _this = this;

      var getIssues = this.list.nextPage();
      var loadingDone = function loadingDone() {
        _this.list.loadingMore = false;
      };

      if (getIssues) {
        this.list.loadingMore = true;
        getIssues.then(loadingDone).catch(loadingDone);
      }
    },
    toggleForm: function toggleForm() {
      this.showIssueForm = !this.showIssueForm;
    },
    onScroll: function onScroll() {
      if (this.scrollTop() > this.scrollHeight() - this.scrollOffset && !this.list.loadingMore) {
        this.loadNextPage();
      }
    }
  },
  watch: {
    filters: {
      handler: function handler() {
        this.list.loadingMore = false;
        this.$refs.list.scrollTop = 0;
      },

      deep: true
    },
    issues: function issues() {
      var _this2 = this;

      this.$nextTick(function () {
        if (_this2.scrollHeight() <= _this2.listHeight() && _this2.list.issuesSize > _this2.list.issues.length) {
          _this2.list.page += 1;
          _this2.list.getIssues(false).catch(function () {
            // TODO: handle request error
          });
        }

        if (_this2.scrollHeight() > Math.ceil(_this2.listHeight())) {
          _this2.showCount = true;
        } else {
          _this2.showCount = false;
        }
      });
    }
  },
  created: function created() {
    __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$on('hide-issue-form-' + this.list.id, this.toggleForm);
    __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$on('scroll-board-list-' + this.list.id, this.scrollToTop);
  },
  mounted: function mounted() {
    var _this3 = this;

    var options = gl.issueBoards.getBoardSortableDefaultOptions({
      scroll: document.querySelectorAll('.boards-list')[0],
      group: 'issues',
      disabled: this.disabled,
      filter: '.board-list-count, .is-disabled',
      dataIdAttr: 'data-issue-id',
      onStart: function onStart(e) {
        var card = _this3.$refs.issue[e.oldIndex];

        card.showDetail = false;
        Store.moving.list = card.list;
        Store.moving.issue = Store.moving.list.findIssue(+e.item.dataset.issueId);

        gl.issueBoards.onStart();
      },
      onAdd: function onAdd(e) {
        gl.issueBoards.BoardsStore.moveIssueToList(Store.moving.list, _this3.list, Store.moving.issue, e.newIndex);

        _this3.$nextTick(function () {
          e.item.remove();
        });
      },
      onUpdate: function onUpdate(e) {
        var sortedArray = _this3.sortable.toArray().filter(function (id) {
          return id !== '-1';
        });
        gl.issueBoards.BoardsStore.moveIssueInList(_this3.list, Store.moving.issue, e.oldIndex, e.newIndex, sortedArray);
      },
      onMove: function onMove(e) {
        return !e.related.classList.contains('board-list-count');
      }
    });

    this.sortable = Sortable.create(this.$refs.list, options);

    // Scroll event on list to load more
    this.$refs.list.addEventListener('scroll', this.onScroll);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$off('hide-issue-form-' + this.list.id, this.toggleForm);
    __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$off('scroll-board-list-' + this.list.id, this.scrollToTop);
    this.$refs.list.removeEventListener('scroll', this.onScroll);
  },

  template: '\n    <div class="board-list-component">\n      <div\n        class="board-list-loading text-center"\n        aria-label="Loading issues"\n        v-if="loading">\n        <loading-icon />\n      </div>\n      <transition name="slide-down">\n        <board-new-issue\n          :list="list"\n          v-if="list.type !== \'closed\' && showIssueForm"/>\n      </transition>\n      <ul\n        class="board-list"\n        v-show="!loading"\n        ref="list"\n        :data-board="list.id"\n        :class="{ \'is-smaller\': showIssueForm }">\n        <board-card\n          v-for="(issue, index) in issues"\n          ref="issue"\n          :index="index"\n          :list="list"\n          :issue="issue"\n          :issue-link-base="issueLinkBase"\n          :root-path="rootPath"\n          :disabled="disabled"\n          :key="issue.id" />\n        <li\n          class="board-list-count text-center"\n          v-if="showCount"\n          data-id="-1">\n\n          <loading-icon\n            v-show="list.loadingMore"\n            label="Loading more issues"\n            />\n\n          <span v-if="list.issues.length === list.issuesSize">\n            Showing all issues\n          </span>\n          <span v-else>\n            Showing {{ list.issues.length }} of {{ list.issuesSize }} issues\n          </span>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/components/board_new_issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__eventhub__ = __webpack_require__("./boards/eventhub.js");
/* global ListIssue */


var Store = gl.issueBoards.BoardsStore;

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'BoardNewIssue',
  props: {
    list: Object
  },
  data: function data() {
    return {
      title: '',
      error: false
    };
  },

  methods: {
    submit: function submit(e) {
      var _this = this;

      e.preventDefault();
      if (this.title.trim() === '') return Promise.resolve();

      this.error = false;

      var labels = this.list.label ? [this.list.label] : [];
      var issue = new ListIssue({
        title: this.title,
        labels: labels,
        subscribed: true,
        assignees: []
      });

      __WEBPACK_IMPORTED_MODULE_0__eventhub__["a" /* default */].$emit('scroll-board-list-' + this.list.id);
      this.cancel();

      return this.list.newIssue(issue).then(function () {
        // Need this because our jQuery very kindly disables buttons on ALL form submissions
        $(_this.$refs.submitButton).enable();

        Store.detail.issue = issue;
        Store.detail.list = _this.list;
      }).catch(function () {
        // Need this because our jQuery very kindly disables buttons on ALL form submissions
        $(_this.$refs.submitButton).enable();

        // Remove the issue
        _this.list.removeIssue(issue);

        // Show error message
        _this.error = true;
      });
    },
    cancel: function cancel() {
      this.title = '';
      __WEBPACK_IMPORTED_MODULE_0__eventhub__["a" /* default */].$emit('hide-issue-form-' + this.list.id);
    }
  },
  mounted: function mounted() {
    this.$refs.input.focus();
  },

  template: '\n    <div class="card board-new-issue-form">\n      <form @submit="submit($event)">\n        <div class="flash-container"\n          v-if="error">\n          <div class="flash-alert">\n            An error occured. Please try again.\n          </div>\n        </div>\n        <label class="label-light"\n          :for="list.id + \'-title\'">\n          Title\n        </label>\n        <input class="form-control"\n          type="text"\n          v-model="title"\n          ref="input"\n          autocomplete="off"\n          :id="list.id + \'-title\'" />\n        <div class="clearfix prepend-top-10">\n          <button class="btn btn-success pull-left"\n            type="submit"\n            :disabled="title === \'\'"\n            ref="submit-button">\n            Submit issue\n          </button>\n          <button class="btn btn-default pull-right"\n            type="button"\n            @click="cancel">\n            Cancel\n          </button>\n        </div>\n      </form>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/board_sidebar.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__ = __webpack_require__("./sidebar/event_hub.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__sidebar_components_assignees_assignee_title__ = __webpack_require__("./sidebar/components/assignees/assignee_title.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__sidebar_components_assignees_assignees__ = __webpack_require__("./sidebar/components/assignees/assignees.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__sidebar_remove_issue__ = __webpack_require__("./boards/components/sidebar/remove_issue.js");
/* eslint-disable comma-dangle, space-before-function-paren, no-new */
/* global IssuableContext */
/* global MilestoneSelect */
/* global LabelsSelect */
/* global Sidebar */
/* global Flash */







var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardSidebar = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    currentUser: Object
  },
  data: function data() {
    return {
      detail: Store.detail,
      issue: {},
      list: {},
      loadingAssignees: false
    };
  },

  computed: {
    showSidebar: function showSidebar() {
      return Object.keys(this.issue).length;
    },
    milestoneTitle: function milestoneTitle() {
      return this.issue.milestone ? this.issue.milestone.title : 'No Milestone';
    },
    canRemove: function canRemove() {
      return !this.list.preset;
    }
  },
  watch: {
    detail: {
      handler: function handler() {
        var _this = this;

        if (this.issue.id !== this.detail.issue.id) {
          $('.block.assignee').find('input:not(.js-vue)[name="issue[assignee_ids][]"]').each(function (i, el) {
            $(el).remove();
          });

          $('.js-issue-board-sidebar', this.$el).each(function (i, el) {
            $(el).data('glDropdown').clearMenu();
          });
        }

        this.issue = this.detail.issue;
        this.list = this.detail.list;

        this.$nextTick(function () {
          _this.endpoint = _this.$refs.assigneeDropdown.dataset.issueUpdate;
        });
      },

      deep: true
    }
  },
  methods: {
    closeSidebar: function closeSidebar() {
      this.detail.issue = {};
    },
    assignSelf: function assignSelf() {
      // Notify gl dropdown that we are now assigning to current user
      this.$refs.assigneeBlock.dispatchEvent(new Event('assignYourself'));

      this.addAssignee(this.currentUser);
      this.saveAssignees();
    },
    removeAssignee: function removeAssignee(a) {
      gl.issueBoards.BoardsStore.detail.issue.removeAssignee(a);
    },
    addAssignee: function addAssignee(a) {
      gl.issueBoards.BoardsStore.detail.issue.addAssignee(a);
    },
    removeAllAssignees: function removeAllAssignees() {
      gl.issueBoards.BoardsStore.detail.issue.removeAllAssignees();
    },
    saveAssignees: function saveAssignees() {
      var _this2 = this;

      this.loadingAssignees = true;

      gl.issueBoards.BoardsStore.detail.issue.update(this.endpoint).then(function () {
        _this2.loadingAssignees = false;
      }).catch(function () {
        _this2.loadingAssignees = false;
        return new Flash('An error occurred while saving assignees');
      });
    }
  },
  created: function created() {
    // Get events from glDropdown
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$on('sidebar.saveAssignees', this.saveAssignees);
  },
  beforeDestroy: function beforeDestroy() {
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.removeAssignee', this.removeAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.addAssignee', this.addAssignee);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.removeAllAssignees', this.removeAllAssignees);
    __WEBPACK_IMPORTED_MODULE_1__sidebar_event_hub__["a" /* default */].$off('sidebar.saveAssignees', this.saveAssignees);
  },
  mounted: function mounted() {
    new IssuableContext(this.currentUser);
    new MilestoneSelect();
    new gl.DueDateSelectors();
    new LabelsSelect();
    new Sidebar();
    gl.Subscription.bindAll('.subscription');
  },

  components: {
    removeBtn: gl.issueBoards.RemoveIssueBtn,
    'assignee-title': __WEBPACK_IMPORTED_MODULE_2__sidebar_components_assignees_assignee_title__["a" /* default */],
    assignees: __WEBPACK_IMPORTED_MODULE_3__sidebar_components_assignees_assignees__["a" /* default */]
  }
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/issue_card_inner.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_link_vue__ = __webpack_require__("./vue_shared/components/user_avatar/user_avatar_link.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_link_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_link_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__eventhub__ = __webpack_require__("./boards/eventhub.js");




var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.IssueCardInner = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    issue: {
      type: Object,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    list: {
      type: Object,
      required: false,
      default: function _default() {
        return {};
      }
    },
    rootPath: {
      type: String,
      required: true
    },
    updateFilters: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  data: function data() {
    return {
      limitBeforeCounter: 3,
      maxRender: 4,
      maxCounter: 99
    };
  },

  components: {
    userAvatarLink: __WEBPACK_IMPORTED_MODULE_1__vue_shared_components_user_avatar_user_avatar_link_vue___default.a
  },
  computed: {
    numberOverLimit: function numberOverLimit() {
      return this.issue.assignees.length - this.limitBeforeCounter;
    },
    assigneeCounterTooltip: function assigneeCounterTooltip() {
      return this.assigneeCounterLabel + ' more';
    },
    assigneeCounterLabel: function assigneeCounterLabel() {
      if (this.numberOverLimit > this.maxCounter) {
        return this.maxCounter + '+';
      }

      return '+' + this.numberOverLimit;
    },
    shouldRenderCounter: function shouldRenderCounter() {
      if (this.issue.assignees.length <= this.maxRender) {
        return false;
      }

      return this.issue.assignees.length > this.numberOverLimit;
    },
    cardUrl: function cardUrl() {
      return this.issueLinkBase + '/' + this.issue.id;
    },
    issueId: function issueId() {
      return '#' + this.issue.id;
    },
    showLabelFooter: function showLabelFooter() {
      var _this = this;

      return this.issue.labels.find(function (l) {
        return _this.showLabel(l);
      }) !== undefined;
    }
  },
  methods: {
    isIndexLessThanlimit: function isIndexLessThanlimit(index) {
      return index < this.limitBeforeCounter;
    },
    shouldRenderAssignee: function shouldRenderAssignee(index) {
      // Eg. maxRender is 4,
      // Render up to all 4 assignees if there are only 4 assigness
      // Otherwise render up to the limitBeforeCounter
      if (this.issue.assignees.length <= this.maxRender) {
        return index < this.maxRender;
      }

      return index < this.limitBeforeCounter;
    },
    assigneeUrl: function assigneeUrl(assignee) {
      return '' + this.rootPath + assignee.username;
    },
    assigneeUrlTitle: function assigneeUrlTitle(assignee) {
      return 'Assigned to ' + assignee.name;
    },
    avatarUrlTitle: function avatarUrlTitle(assignee) {
      return 'Avatar for ' + assignee.name;
    },
    showLabel: function showLabel(label) {
      if (!label.id) return false;
      return true;
    },
    filterByLabel: function filterByLabel(label, e) {
      if (!this.updateFilters) return;

      var filterPath = gl.issueBoards.BoardsStore.filter.path.split('&');
      var labelTitle = encodeURIComponent(label.title);
      var param = 'label_name[]=' + labelTitle;
      var labelIndex = filterPath.indexOf(param);
      $(e.currentTarget).tooltip('hide');

      if (labelIndex === -1) {
        filterPath.push(param);
      } else {
        filterPath.splice(labelIndex, 1);
      }

      gl.issueBoards.BoardsStore.filter.path = filterPath.join('&');

      Store.updateFiltersUrl();

      __WEBPACK_IMPORTED_MODULE_2__eventhub__["a" /* default */].$emit('updateTokens');
    },
    labelStyle: function labelStyle(label) {
      return {
        backgroundColor: label.color,
        color: label.textColor
      };
    }
  },
  template: '\n    <div>\n      <div class="card-header">\n        <h4 class="card-title">\n          <i\n            class="fa fa-eye-slash confidential-icon"\n            v-if="issue.confidential"\n            aria-hidden="true"\n          />\n          <a\n            class="js-no-trigger"\n            :href="cardUrl"\n            :title="issue.title">{{ issue.title }}</a>\n          <span\n            class="card-number"\n            v-if="issue.id"\n          >\n            {{ issueId }}\n          </span>\n        </h4>\n        <div class="card-assignee">\n          <user-avatar-link\n            v-for="(assignee, index) in issue.assignees"\n            :key="assignee.id"\n            v-if="shouldRenderAssignee(index)"\n            class="js-no-trigger"\n            :link-href="assigneeUrl(assignee)"\n            :img-alt="avatarUrlTitle(assignee)"\n            :img-src="assignee.avatar"\n            :tooltip-text="assigneeUrlTitle(assignee)"\n            tooltip-placement="bottom"\n          />\n          <span\n            class="avatar-counter has-tooltip"\n            :title="assigneeCounterTooltip"\n            v-if="shouldRenderCounter"\n          >\n           {{ assigneeCounterLabel }}\n          </span>\n        </div>\n      </div>\n      <div\n        class="card-footer"\n        v-if="showLabelFooter"\n      >\n        <button\n          class="label color-label has-tooltip"\n          v-for="label in issue.labels"\n          type="button"\n          v-if="showLabel(label)"\n          @click="filterByLabel(label, $event)"\n          :style="labelStyle(label)"\n          :title="label.description"\n          data-container="body">\n          {{ label.title }}\n        </button>\n      </div>\n    </div>\n  '
});
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/modal/empty_state.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalEmptyState = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return ModalStore.store;
  },

  props: {
    image: {
      type: String,
      required: true
    },
    newIssuePath: {
      type: String,
      required: true
    }
  },
  computed: {
    contents: function contents() {
      var obj = {
        title: 'You haven\'t added any issues to your project yet',
        content: '\n          An issue can be a bug, a todo or a feature request that needs to be\n          discussed in a project. Besides, issues are searchable and filterable.\n        '
      };

      if (this.activeTab === 'selected') {
        obj.title = 'You haven\'t selected any issues yet';
        obj.content = '\n          Go back to <strong>Open issues</strong> and select some issues\n          to add to your board.\n        ';
      }

      return obj;
    }
  },
  template: '\n    <section class="empty-state">\n      <div class="row">\n        <div class="col-xs-12 col-sm-6 col-sm-push-6">\n          <aside class="svg-content" v-html="image"></aside>\n        </div>\n        <div class="col-xs-12 col-sm-6 col-sm-pull-6">\n          <div class="text-content">\n            <h4>{{ contents.title }}</h4>\n            <p v-html="contents.content"></p>\n            <a\n              :href="newIssuePath"\n              class="btn btn-success btn-inverted"\n              v-if="activeTab === \'all\'">\n              New issue\n            </a>\n            <button\n              type="button"\n              class="btn btn-default"\n              @click="changeTab(\'all\')"\n              v-if="activeTab === \'selected\'">\n              Open issues\n            </button>\n          </div>\n        </div>\n      </div>\n    </section>\n  '
});

/***/ }),

/***/ "./boards/components/modal/filters.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_boards__ = __webpack_require__("./boards/filtered_search_boards.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filtered_search_container__ = __webpack_require__("./filtered_search/container.js");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'modal-filters',
  props: {
    store: {
      type: Object,
      required: true
    }
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_1__filtered_search_container__["a" /* default */].container = this.$el;

    this.filteredSearch = new __WEBPACK_IMPORTED_MODULE_0__filtered_search_boards__["a" /* default */](this.store);
    this.filteredSearch.setup();
    this.filteredSearch.removeTokens();
    this.filteredSearch.handleInputPlaceholder();
    this.filteredSearch.toggleClearSearchButton();
  },
  destroyed: function destroyed() {
    this.filteredSearch.cleanup();
    __WEBPACK_IMPORTED_MODULE_1__filtered_search_container__["a" /* default */].container = document;
    this.store.path = '';
  },

  template: '#js-board-modal-filter'
});

/***/ }),

/***/ "./boards/components/modal/footer.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__lists_dropdown__ = __webpack_require__("./boards/components/modal/lists_dropdown.js");
/* eslint-disable no-new */
/* global Flash */




var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalFooter = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return {
      modal: ModalStore.store,
      state: gl.issueBoards.BoardsStore.state
    };
  },

  computed: {
    submitDisabled: function submitDisabled() {
      return !ModalStore.selectedCount();
    },
    submitText: function submitText() {
      var count = ModalStore.selectedCount();

      return 'Add ' + (count > 0 ? count : '') + ' ' + gl.text.pluralize('issue', count);
    }
  },
  methods: {
    addIssues: function addIssues() {
      var firstListIndex = 1;
      var list = this.modal.selectedList || this.state.lists[firstListIndex];
      var selectedIssues = ModalStore.getSelectedIssues();
      var issueIds = selectedIssues.map(function (issue) {
        return issue.globalId;
      });

      // Post the data to the backend
      gl.boardService.bulkUpdate(issueIds, {
        add_label_ids: [list.label.id]
      }).catch(function () {
        new Flash('Failed to update issues, please try again.', 'alert');

        selectedIssues.forEach(function (issue) {
          list.removeIssue(issue);
          list.issuesSize -= 1;
        });
      });

      // Add the issues on the frontend
      selectedIssues.forEach(function (issue) {
        list.addIssue(issue);
        list.issuesSize += 1;
      });

      this.toggleModal(false);
    }
  },
  components: {
    'lists-dropdown': gl.issueBoards.ModalFooterListsDropdown
  },
  template: '\n    <footer\n      class="form-actions add-issues-footer">\n      <div class="pull-left">\n        <button\n          class="btn btn-success"\n          type="button"\n          :disabled="submitDisabled"\n          @click="addIssues">\n          {{ submitText }}\n        </button>\n        <span class="inline add-issues-footer-to-list">\n          to list\n        </span>\n        <lists-dropdown></lists-dropdown>\n      </div>\n      <button\n        class="btn btn-default pull-right"\n        type="button"\n        @click="toggleModal(false)">\n        Cancel\n      </button>\n    </footer>\n  '
});

/***/ }),

/***/ "./boards/components/modal/header.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__filters__ = __webpack_require__("./boards/components/modal/filters.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__tabs__ = __webpack_require__("./boards/components/modal/tabs.js");




var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalHeader = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  props: {
    projectId: {
      type: Number,
      required: true
    },
    milestonePath: {
      type: String,
      required: true
    },
    labelPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return ModalStore.store;
  },

  computed: {
    selectAllText: function selectAllText() {
      if (ModalStore.selectedCount() !== this.issues.length || this.issues.length === 0) {
        return 'Select all';
      }

      return 'Deselect all';
    },
    showSearch: function showSearch() {
      return this.activeTab === 'all' && !this.loading && this.issuesCount > 0;
    }
  },
  methods: {
    toggleAll: function toggleAll() {
      this.$refs.selectAllBtn.blur();

      ModalStore.toggleAll();
    }
  },
  components: {
    'modal-tabs': gl.issueBoards.ModalTabs,
    modalFilters: __WEBPACK_IMPORTED_MODULE_1__filters__["a" /* default */]
  },
  template: '\n    <div>\n      <header class="add-issues-header form-actions">\n        <h2>\n          Add issues\n          <button\n            type="button"\n            class="close"\n            data-dismiss="modal"\n            aria-label="Close"\n            @click="toggleModal(false)">\n            <span aria-hidden="true">\xD7</span>\n          </button>\n        </h2>\n      </header>\n      <modal-tabs v-if="!loading && issuesCount > 0"></modal-tabs>\n      <div\n        class="add-issues-search append-bottom-10"\n        v-if="showSearch">\n        <modal-filters :store="filter" />\n        <button\n          type="button"\n          class="btn btn-success btn-inverted prepend-left-10"\n          ref="selectAllBtn"\n          @click="toggleAll">\n          {{ selectAllText }}\n        </button>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/components/modal/index.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__boards_utils_query_data__ = __webpack_require__("./boards/utils/query_data.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__ = __webpack_require__("./vue_shared/components/loading_icon.vue");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__header__ = __webpack_require__("./boards/components/modal/header.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__list__ = __webpack_require__("./boards/components/modal/list.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__footer__ = __webpack_require__("./boards/components/modal/footer.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__empty_state__ = __webpack_require__("./boards/components/modal/empty_state.js");
/* global ListIssue */









var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.IssuesModal = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    blankStateImage: {
      type: String,
      required: true
    },
    newIssuePath: {
      type: String,
      required: true
    },
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    },
    projectId: {
      type: Number,
      required: true
    },
    milestonePath: {
      type: String,
      required: true
    },
    labelPath: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return ModalStore.store;
  },

  watch: {
    page: function page() {
      this.loadIssues();
    },
    showAddIssuesModal: function showAddIssuesModal() {
      var _this = this;

      if (this.showAddIssuesModal && !this.issues.length) {
        this.loading = true;
        var loadingDone = function loadingDone() {
          _this.loading = false;
        };

        this.loadIssues().then(loadingDone).catch(loadingDone);
      } else if (!this.showAddIssuesModal) {
        this.issues = [];
        this.selectedIssues = [];
        this.issuesCount = false;
      }
    },

    filter: {
      handler: function handler() {
        var _this2 = this;

        if (this.$el.tagName) {
          this.page = 1;
          this.filterLoading = true;
          var loadingDone = function loadingDone() {
            _this2.filterLoading = false;
          };

          this.loadIssues(true).then(loadingDone).catch(loadingDone);
        }
      },

      deep: true
    }
  },
  methods: {
    loadIssues: function loadIssues() {
      var _this3 = this;

      var clearIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (!this.showAddIssuesModal) return false;

      return gl.boardService.getBacklog(Object(__WEBPACK_IMPORTED_MODULE_1__boards_utils_query_data__["a" /* default */])(this.filter.path, {
        page: this.page,
        per: this.perPage
      })).then(function (resp) {
        return resp.json();
      }).then(function (data) {
        if (clearIssues) {
          _this3.issues = [];
        }

        data.issues.forEach(function (issueObj) {
          var issue = new ListIssue(issueObj);
          var foundSelectedIssue = ModalStore.findSelectedIssue(issue);
          issue.selected = !!foundSelectedIssue;

          _this3.issues.push(issue);
        });

        _this3.loadingNewPage = false;

        if (!_this3.issuesCount) {
          _this3.issuesCount = data.size;
        }
      }).catch(function () {
        // TODO: handle request error
      });
    }
  },
  computed: {
    showList: function showList() {
      if (this.activeTab === 'selected') {
        return this.selectedIssues.length > 0;
      }

      return this.issuesCount > 0;
    },
    showEmptyState: function showEmptyState() {
      if (!this.loading && this.issuesCount === 0) {
        return true;
      }

      return this.activeTab === 'selected' && this.selectedIssues.length === 0;
    }
  },
  created: function created() {
    this.page = 1;
  },

  components: {
    'modal-header': gl.issueBoards.ModalHeader,
    'modal-list': gl.issueBoards.ModalList,
    'modal-footer': gl.issueBoards.ModalFooter,
    'empty-state': gl.issueBoards.ModalEmptyState,
    loadingIcon: __WEBPACK_IMPORTED_MODULE_2__vue_shared_components_loading_icon_vue___default.a
  },
  template: '\n    <div\n      class="add-issues-modal"\n      v-if="showAddIssuesModal">\n      <div class="add-issues-container">\n        <modal-header\n          :project-id="projectId"\n          :milestone-path="milestonePath"\n          :label-path="labelPath">\n        </modal-header>\n        <modal-list\n          :image="blankStateImage"\n          :issue-link-base="issueLinkBase"\n          :root-path="rootPath"\n          v-if="!loading && showList && !filterLoading"></modal-list>\n        <empty-state\n          v-if="showEmptyState"\n          :image="blankStateImage"\n          :new-issue-path="newIssuePath"></empty-state>\n        <section\n          class="add-issues-list text-center"\n          v-if="loading || filterLoading">\n          <div class="add-issues-list-loading">\n            <loading-icon />\n          </div>\n        </section>\n        <modal-footer></modal-footer>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/components/modal/list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__breakpoints__ = __webpack_require__("./breakpoints.js");
/* global ListIssue */




var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalList = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    issueLinkBase: {
      type: String,
      required: true
    },
    rootPath: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    }
  },
  data: function data() {
    return ModalStore.store;
  },

  watch: {
    activeTab: function activeTab() {
      if (this.activeTab === 'all') {
        ModalStore.purgeUnselectedIssues();
      }
    }
  },
  computed: {
    loopIssues: function loopIssues() {
      if (this.activeTab === 'all') {
        return this.issues;
      }

      return this.selectedIssues;
    },
    groupedIssues: function groupedIssues() {
      var _this = this;

      var groups = [];
      this.loopIssues.forEach(function (issue, i) {
        var index = i % _this.columns;

        if (!groups[index]) {
          groups.push([]);
        }

        groups[index].push(issue);
      });

      return groups;
    }
  },
  methods: {
    scrollHandler: function scrollHandler() {
      var currentPage = Math.floor(this.issues.length / this.perPage);

      if (this.scrollTop() > this.scrollHeight() - 100 && !this.loadingNewPage && currentPage === this.page) {
        this.loadingNewPage = true;
        this.page += 1;
      }
    },
    toggleIssue: function toggleIssue(e, issue) {
      if (e.target.tagName !== 'A') {
        ModalStore.toggleIssue(issue);
      }
    },
    listHeight: function listHeight() {
      return this.$refs.list.getBoundingClientRect().height;
    },
    scrollHeight: function scrollHeight() {
      return this.$refs.list.scrollHeight;
    },
    scrollTop: function scrollTop() {
      return this.$refs.list.scrollTop + this.listHeight();
    },
    showIssue: function showIssue(issue) {
      if (this.activeTab === 'all') return true;

      var index = ModalStore.selectedIssueIndex(issue);

      return index !== -1;
    },
    setColumnCount: function setColumnCount() {
      var breakpoint = __WEBPACK_IMPORTED_MODULE_1__breakpoints__["a" /* default */].getBreakpointSize();

      if (breakpoint === 'lg' || breakpoint === 'md') {
        this.columns = 3;
      } else if (breakpoint === 'sm') {
        this.columns = 2;
      } else {
        this.columns = 1;
      }
    }
  },
  mounted: function mounted() {
    this.scrollHandlerWrapper = this.scrollHandler.bind(this);
    this.setColumnCountWrapper = this.setColumnCount.bind(this);
    this.setColumnCount();

    this.$refs.list.addEventListener('scroll', this.scrollHandlerWrapper);
    window.addEventListener('resize', this.setColumnCountWrapper);
  },
  beforeDestroy: function beforeDestroy() {
    this.$refs.list.removeEventListener('scroll', this.scrollHandlerWrapper);
    window.removeEventListener('resize', this.setColumnCountWrapper);
  },

  components: {
    'issue-card-inner': gl.issueBoards.IssueCardInner
  },
  template: '\n    <section\n      class="add-issues-list add-issues-list-columns"\n      ref="list">\n      <div\n        class="empty-state add-issues-empty-state-filter text-center"\n        v-if="issuesCount > 0 && issues.length === 0">\n        <div\n          class="svg-content"\n          v-html="image">\n        </div>\n        <div class="text-content">\n          <h4>\n            There are no issues to show.\n          </h4>\n        </div>\n      </div>\n      <div\n        v-for="group in groupedIssues"\n        class="add-issues-list-column">\n        <div\n          v-for="issue in group"\n          v-if="showIssue(issue)"\n          class="card-parent">\n          <div\n            class="card"\n            :class="{ \'is-active\': issue.selected }"\n            @click="toggleIssue($event, issue)">\n            <issue-card-inner\n              :issue="issue"\n              :issue-link-base="issueLinkBase"\n              :root-path="rootPath">\n            </issue-card-inner>\n            <span\n              :aria-label="\'Issue #\' + issue.id + \' selected\'"\n              aria-checked="true"\n              v-if="issue.selected"\n              class="issue-card-selected text-center">\n              <i class="fa fa-check"></i>\n            </span>\n          </div>\n        </div>\n      </div>\n    </section>\n  '
});

/***/ }),

/***/ "./boards/components/modal/lists_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalFooterListsDropdown = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  data: function data() {
    return {
      modal: ModalStore.store,
      state: gl.issueBoards.BoardsStore.state
    };
  },

  computed: {
    selected: function selected() {
      return this.modal.selectedList || this.state.lists[1];
    }
  },
  destroyed: function destroyed() {
    this.modal.selectedList = null;
  },

  template: '\n    <div class="dropdown inline">\n      <button\n        class="dropdown-menu-toggle"\n        type="button"\n        data-toggle="dropdown"\n        aria-expanded="false">\n        <span\n          class="dropdown-label-box"\n          :style="{ backgroundColor: selected.label.color }">\n        </span>\n        {{ selected.title }}\n        <i class="fa fa-chevron-down"></i>\n      </button>\n      <div class="dropdown-menu dropdown-menu-selectable dropdown-menu-drop-up">\n        <ul>\n          <li\n            v-for="list in state.lists"\n            v-if="list.type == \'label\'">\n            <a\n              href="#"\n              role="button"\n              :class="{ \'is-active\': list.id == selected.id }"\n              @click.prevent="modal.selectedList = list">\n              <span\n                class="dropdown-label-box"\n                :style="{ backgroundColor: list.label.color }">\n              </span>\n              {{ list.title }}\n            </a>\n          </li>\n        </ul>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/components/modal/tabs.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalTabs = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  mixins: [gl.issueBoards.ModalMixins],
  data: function data() {
    return ModalStore.store;
  },

  computed: {
    selectedCount: function selectedCount() {
      return ModalStore.selectedCount();
    }
  },
  destroyed: function destroyed() {
    this.activeTab = 'all';
  },

  template: '\n    <div class="top-area prepend-top-10 append-bottom-10">\n      <ul class="nav-links issues-state-filters">\n        <li :class="{ \'active\': activeTab == \'all\' }">\n          <a\n            href="#"\n            role="button"\n            @click.prevent="changeTab(\'all\')">\n            Open issues\n            <span class="badge">\n              {{ issuesCount }}\n            </span>\n          </a>\n        </li>\n        <li :class="{ \'active\': activeTab == \'selected\' }">\n          <a\n            href="#"\n            role="button"\n            @click.prevent="changeTab(\'selected\')">\n            Selected issues\n            <span class="badge">\n              {{ selectedCount }}\n            </span>\n          </a>\n        </li>\n      </ul>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/components/new_list_dropdown.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* eslint-disable comma-dangle, func-names, no-new, space-before-function-paren, one-var,
   promise/catch-or-return */


window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

var Store = gl.issueBoards.BoardsStore;

$(document).off('created.label').on('created.label', function (e, label) {
  Store.new({
    title: label.title,
    position: Store.state.lists.length - 2,
    list_type: 'label',
    label: {
      id: label.id,
      title: label.title,
      color: label.color
    }
  });
});

gl.issueBoards.newListDropdownInit = function () {
  $('.js-new-board-list').each(function () {
    var $this = $(this);
    new gl.CreateLabelDropdown($this.closest('.dropdown').find('.dropdown-new-label'), $this.data('namespace-path'), $this.data('project-path'));

    $this.glDropdown({
      data: function data(term, callback) {
        $.get($this.attr('data-labels')).then(function (resp) {
          callback(resp);
        });
      },
      renderRow: function renderRow(label) {
        var active = Store.findList('title', label.title);
        var $li = $('<li />');
        var $a = $('<a />', {
          class: active ? 'is-active js-board-list-' + active.id : '',
          text: label.title,
          href: '#'
        });
        var $labelColor = $('<span />', {
          class: 'dropdown-label-box',
          style: 'background-color: ' + label.color
        });

        return $li.append($a.prepend($labelColor));
      },

      search: {
        fields: ['title']
      },
      filterable: true,
      selectable: true,
      multiSelect: true,
      clicked: function clicked(options) {
        var e = options.e;

        var label = options.selectedObj;
        e.preventDefault();

        if (!Store.findList('title', label.title)) {
          Store.new({
            title: label.title,
            position: Store.state.lists.length - 2,
            list_type: 'label',
            label: {
              id: label.id,
              title: label.title,
              color: label.color
            }
          });

          Store.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(Store.state.lists, 'position');
        }
      }
    });
  });
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/components/sidebar/remove_issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* eslint-disable no-new */
/* global Flash */



var Store = gl.issueBoards.BoardsStore;

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.RemoveIssueBtn = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].extend({
  props: {
    issue: {
      type: Object,
      required: true
    },
    list: {
      type: Object,
      required: true
    }
  },
  methods: {
    removeIssue: function removeIssue() {
      var issue = this.issue;
      var lists = issue.getLists();
      var labelIds = lists.map(function (list) {
        return list.label.id;
      });

      // Post the remove data
      gl.boardService.bulkUpdate([issue.globalId], {
        remove_label_ids: labelIds
      }).catch(function () {
        new Flash('Failed to remove issue from board, please try again.', 'alert');

        lists.forEach(function (list) {
          list.addIssue(issue);
        });
      });

      // Remove from the frontend store
      lists.forEach(function (list) {
        list.removeIssue(issue);
      });

      Store.detail.issue = {};
    }
  },
  template: '\n    <div\n      class="block list">\n      <button\n        class="btn btn-default btn-block"\n        type="button"\n        @click="removeIssue">\n        Remove from board\n      </button>\n    </div>\n  '
});

/***/ }),

/***/ "./boards/eventhub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]());

/***/ }),

/***/ "./boards/filtered_search_boards.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__filtered_search_container__ = __webpack_require__("./filtered_search/container.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/* eslint-disable class-methods-use-this */


var FilteredSearchBoards = function (_gl$FilteredSearchMan) {
  _inherits(FilteredSearchBoards, _gl$FilteredSearchMan);

  function FilteredSearchBoards(store) {
    var updateUrl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    var cantEdit = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

    _classCallCheck(this, FilteredSearchBoards);

    var _this = _possibleConstructorReturn(this, (FilteredSearchBoards.__proto__ || Object.getPrototypeOf(FilteredSearchBoards)).call(this, 'boards'));

    _this.store = store;
    _this.updateUrl = updateUrl;

    // Issue boards is slightly different, we handle all the requests async
    // instead or reloading the page, we just re-fire the list ajax requests
    _this.isHandledAsync = true;
    _this.cantEdit = cantEdit;
    return _this;
  }

  _createClass(FilteredSearchBoards, [{
    key: 'updateObject',
    value: function updateObject(path) {
      this.store.path = path.substr(1);

      if (this.updateUrl) {
        gl.issueBoards.BoardsStore.updateFiltersUrl();
      }
    }
  }, {
    key: 'removeTokens',
    value: function removeTokens() {
      var tokens = __WEBPACK_IMPORTED_MODULE_0__filtered_search_container__["a" /* default */].container.querySelectorAll('.js-visual-token');

      // Remove all the tokens as they will be replaced by the search manager
      [].forEach.call(tokens, function (el) {
        el.parentNode.removeChild(el);
      });

      this.filteredSearchInput.value = '';
    }
  }, {
    key: 'updateTokens',
    value: function updateTokens() {
      this.removeTokens();

      this.loadSearchParamsFromURL();

      // Get the placeholder back if search is empty
      this.filteredSearchInput.dispatchEvent(new Event('input'));
    }
  }, {
    key: 'canEdit',
    value: function canEdit(tokenName) {
      return this.cantEdit.indexOf(tokenName) === -1;
    }
  }]);

  return FilteredSearchBoards;
}(gl.FilteredSearchManager);

/* harmony default export */ __webpack_exports__["a"] = (FilteredSearchBoards);

/***/ }),

/***/ "./boards/filters/due_date_filters.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
/* global dateFormat */



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].filter('due-date', function (value) {
  var date = new Date(value);
  return dateFormat(date, 'mmm d, yyyy', true);
});

/***/ }),

/***/ "./boards/mixins/modal_mixins.js":
/***/ (function(module, exports) {

var ModalStore = gl.issueBoards.ModalStore;

gl.issueBoards.ModalMixins = {
  methods: {
    toggleModal: function toggleModal(toggle) {
      ModalStore.store.showAddIssuesModal = toggle;
    },
    changeTab: function changeTab(tab) {
      ModalStore.store.activeTab = tab;
    }
  }
};

/***/ }),

/***/ "./boards/mixins/sortable_default_options.js":
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function($) {/* eslint-disable no-unused-vars, no-mixed-operators, comma-dangle */
/* global DocumentTouch */

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.onStart = function () {
  $('.has-tooltip').tooltip('hide').tooltip('disable');
  document.body.classList.add('is-dragging');
};

gl.issueBoards.onEnd = function () {
  $('.has-tooltip').tooltip('enable');
  document.body.classList.remove('is-dragging');
};

gl.issueBoards.touchEnabled = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;

gl.issueBoards.getBoardSortableDefaultOptions = function (obj) {
  var defaultSortOptions = {
    animation: 200,
    forceFallback: true,
    fallbackClass: 'is-dragging',
    fallbackOnBody: true,
    ghostClass: 'is-ghost',
    filter: '.board-delete, .btn',
    delay: gl.issueBoards.touchEnabled ? 100 : 0,
    scrollSensitivity: gl.issueBoards.touchEnabled ? 60 : 100,
    scrollSpeed: 20,
    onStart: gl.issueBoards.onStart,
    onEnd: gl.issueBoards.onEnd
  };

  Object.keys(obj).forEach(function (key) {
    defaultSortOptions[key] = obj[key];
  });
  return defaultSortOptions;
};
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/models/assignee.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars */

var ListAssignee = function ListAssignee(user, defaultAvatar) {
  _classCallCheck(this, ListAssignee);

  this.id = user.id;
  this.name = user.name;
  this.username = user.username;
  this.avatar = user.avatar_url || defaultAvatar;
};

window.ListAssignee = ListAssignee;

/***/ }),

/***/ "./boards/models/issue.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars, space-before-function-paren, arrow-body-style, arrow-parens, comma-dangle, max-len */
/* global ListLabel */
/* global ListMilestone */
/* global ListAssignee */



var ListIssue = function () {
  function ListIssue(obj, defaultAvatar) {
    var _this = this;

    _classCallCheck(this, ListIssue);

    this.globalId = obj.id;
    this.id = obj.iid;
    this.title = obj.title;
    this.confidential = obj.confidential;
    this.dueDate = obj.due_date;
    this.subscribed = obj.subscribed;
    this.labels = [];
    this.assignees = [];
    this.selected = false;
    this.position = obj.relative_position || Infinity;

    if (obj.milestone) {
      this.milestone = new ListMilestone(obj.milestone);
    }

    obj.labels.forEach(function (label) {
      _this.labels.push(new ListLabel(label));
    });

    this.assignees = obj.assignees.map(function (a) {
      return new ListAssignee(a, defaultAvatar);
    });
  }

  _createClass(ListIssue, [{
    key: 'addLabel',
    value: function addLabel(label) {
      if (!this.findLabel(label)) {
        this.labels.push(new ListLabel(label));
      }
    }
  }, {
    key: 'findLabel',
    value: function findLabel(_findLabel) {
      return this.labels.filter(function (label) {
        return label.title === _findLabel.title;
      })[0];
    }
  }, {
    key: 'removeLabel',
    value: function removeLabel(_removeLabel) {
      if (_removeLabel) {
        this.labels = this.labels.filter(function (label) {
          return _removeLabel.title !== label.title;
        });
      }
    }
  }, {
    key: 'removeLabels',
    value: function removeLabels(labels) {
      labels.forEach(this.removeLabel.bind(this));
    }
  }, {
    key: 'addAssignee',
    value: function addAssignee(assignee) {
      if (!this.findAssignee(assignee)) {
        this.assignees.push(new ListAssignee(assignee));
      }
    }
  }, {
    key: 'findAssignee',
    value: function findAssignee(_findAssignee) {
      return this.assignees.filter(function (assignee) {
        return assignee.id === _findAssignee.id;
      })[0];
    }
  }, {
    key: 'removeAssignee',
    value: function removeAssignee(_removeAssignee) {
      if (_removeAssignee) {
        this.assignees = this.assignees.filter(function (assignee) {
          return assignee.id !== _removeAssignee.id;
        });
      }
    }
  }, {
    key: 'removeAllAssignees',
    value: function removeAllAssignees() {
      this.assignees = [];
    }
  }, {
    key: 'getLists',
    value: function getLists() {
      var _this2 = this;

      return gl.issueBoards.BoardsStore.state.lists.filter(function (list) {
        return list.findIssue(_this2.id);
      });
    }
  }, {
    key: 'update',
    value: function update(url) {
      var data = {
        issue: {
          milestone_id: this.milestone ? this.milestone.id : null,
          due_date: this.dueDate,
          assignee_ids: this.assignees.length > 0 ? this.assignees.map(function (u) {
            return u.id;
          }) : [0],
          label_ids: this.labels.map(function (label) {
            return label.id;
          })
        }
      };

      if (!data.issue.label_ids.length) {
        data.issue.label_ids = [''];
      }

      return __WEBPACK_IMPORTED_MODULE_0_vue__["default"].http.patch(url, data);
    }
  }]);

  return ListIssue;
}();

window.ListIssue = ListIssue;

/***/ }),

/***/ "./boards/models/label.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars, space-before-function-paren */

var ListLabel = function ListLabel(obj) {
  _classCallCheck(this, ListLabel);

  this.id = obj.id;
  this.title = obj.title;
  this.color = obj.color;
  this.textColor = obj.text_color;
  this.description = obj.description;
  this.priority = obj.priority !== null ? obj.priority : Infinity;
};

window.ListLabel = ListLabel;

/***/ }),

/***/ "./boards/models/list.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_query_data__ = __webpack_require__("./boards/utils/query_data.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, no-underscore-dangle, class-methods-use-this, consistent-return, no-shadow, no-param-reassign, max-len, no-unused-vars */
/* global ListIssue */
/* global ListLabel */


var PER_PAGE = 20;

var List = function () {
  function List(obj, defaultAvatar) {
    _classCallCheck(this, List);

    this.id = obj.id;
    this._uid = this.guid();
    this.position = obj.position;
    this.title = obj.title;
    this.type = obj.list_type;
    this.preset = ['backlog', 'closed', 'blank'].indexOf(this.type) > -1;
    this.isExpandable = ['backlog', 'closed'].indexOf(this.type) > -1;
    this.isExpanded = true;
    this.page = 1;
    this.loading = true;
    this.loadingMore = false;
    this.issues = [];
    this.issuesSize = 0;
    this.defaultAvatar = defaultAvatar;

    if (obj.label) {
      this.label = new ListLabel(obj.label);
    }

    if (this.type !== 'blank' && this.id) {
      this.getIssues().catch(function () {
        // TODO: handle request error
      });
    }
  }

  _createClass(List, [{
    key: 'guid',
    value: function guid() {
      var s4 = function s4() {
        return Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
      };
      return '' + s4() + s4() + '-' + s4() + '-' + s4() + '-' + s4() + '-' + s4() + s4() + s4();
    }
  }, {
    key: 'save',
    value: function save() {
      var _this = this;

      return gl.boardService.createList(this.label.id).then(function (resp) {
        return resp.json();
      }).then(function (data) {
        _this.id = data.id;
        _this.type = data.list_type;
        _this.position = data.position;

        return _this.getIssues();
      });
    }
  }, {
    key: 'destroy',
    value: function destroy() {
      var index = gl.issueBoards.BoardsStore.state.lists.indexOf(this);
      gl.issueBoards.BoardsStore.state.lists.splice(index, 1);
      gl.issueBoards.BoardsStore.updateNewListDropdown(this.id);

      gl.boardService.destroyList(this.id).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'update',
    value: function update() {
      gl.boardService.updateList(this.id, this.position).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      if (this.issuesSize > this.issues.length) {
        if (this.issues.length / PER_PAGE >= 1) {
          this.page += 1;
        }

        return this.getIssues(false);
      }
    }
  }, {
    key: 'getIssues',
    value: function getIssues() {
      var _this2 = this;

      var emptyIssues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      var data = Object(__WEBPACK_IMPORTED_MODULE_0__utils_query_data__["a" /* default */])(gl.issueBoards.BoardsStore.filter.path, { page: this.page });

      if (this.label && data.label_name) {
        data.label_name = data.label_name.filter(function (label) {
          return label !== _this2.label.title;
        });
      }

      if (emptyIssues) {
        this.loading = true;
      }

      return gl.boardService.getIssuesForList(this.id, data).then(function (resp) {
        return resp.json();
      }).then(function (data) {
        _this2.loading = false;
        _this2.issuesSize = data.size;

        if (emptyIssues) {
          _this2.issues = [];
        }

        _this2.createIssues(data.issues);
      });
    }
  }, {
    key: 'newIssue',
    value: function newIssue(issue) {
      var _this3 = this;

      this.addIssue(issue, null, 0);
      this.issuesSize += 1;

      return gl.boardService.newIssue(this.id, issue).then(function (resp) {
        return resp.json();
      }).then(function (data) {
        issue.id = data.iid;

        if (_this3.issuesSize > 1) {
          var moveBeforeIid = _this3.issues[1].id;
          gl.boardService.moveIssue(issue.id, null, null, null, moveBeforeIid);
        }
      });
    }
  }, {
    key: 'createIssues',
    value: function createIssues(data) {
      var _this4 = this;

      data.forEach(function (issueObj) {
        _this4.addIssue(new ListIssue(issueObj, _this4.defaultAvatar));
      });
    }
  }, {
    key: 'addIssue',
    value: function addIssue(issue, listFrom, newIndex) {
      var moveBeforeIid = null;
      var moveAfterIid = null;

      if (!this.findIssue(issue.id)) {
        if (newIndex !== undefined) {
          this.issues.splice(newIndex, 0, issue);

          if (this.issues[newIndex - 1]) {
            moveBeforeIid = this.issues[newIndex - 1].id;
          }

          if (this.issues[newIndex + 1]) {
            moveAfterIid = this.issues[newIndex + 1].id;
          }
        } else {
          this.issues.push(issue);
        }

        if (this.label) {
          issue.addLabel(this.label);
        }

        if (listFrom) {
          this.issuesSize += 1;

          this.updateIssueLabel(issue, listFrom, moveBeforeIid, moveAfterIid);
        }
      }
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(issue, oldIndex, newIndex, moveBeforeIid, moveAfterIid) {
      this.issues.splice(oldIndex, 1);
      this.issues.splice(newIndex, 0, issue);

      gl.boardService.moveIssue(issue.id, null, null, moveBeforeIid, moveAfterIid).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'updateIssueLabel',
    value: function updateIssueLabel(issue, listFrom, moveBeforeIid, moveAfterIid) {
      gl.boardService.moveIssue(issue.id, listFrom.id, this.id, moveBeforeIid, moveAfterIid).catch(function () {
        // TODO: handle request error
      });
    }
  }, {
    key: 'findIssue',
    value: function findIssue(id) {
      return this.issues.filter(function (issue) {
        return issue.id === id;
      })[0];
    }
  }, {
    key: 'removeIssue',
    value: function removeIssue(_removeIssue) {
      var _this5 = this;

      this.issues = this.issues.filter(function (issue) {
        var matchesRemove = _removeIssue.id === issue.id;

        if (matchesRemove) {
          _this5.issuesSize -= 1;
          issue.removeLabel(_this5.label);
        }

        return !matchesRemove;
      });
    }
  }]);

  return List;
}();

window.List = List;

/***/ }),

/***/ "./boards/models/milestone.js":
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable no-unused-vars */

var ListMilestone = function ListMilestone(obj) {
  _classCallCheck(this, ListMilestone);

  this.id = obj.id;
  this.title = obj.title;
};

window.ListMilestone = ListMilestone;

/***/ }),

/***/ "./boards/services/board_service.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/* eslint-disable space-before-function-paren, comma-dangle, no-param-reassign, camelcase, max-len, no-unused-vars */



var BoardService = function () {
  function BoardService(root, bulkUpdatePath, boardId) {
    _classCallCheck(this, BoardService);

    this.boards = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '{/id}.json', {}, {
      issues: {
        method: 'GET',
        url: root + '/' + boardId + '/issues.json'
      }
    });
    this.lists = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '/' + boardId + '/lists{/id}', {}, {
      generate: {
        method: 'POST',
        url: root + '/' + boardId + '/lists/generate.json'
      }
    });
    this.issue = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '/' + boardId + '/issues{/id}', {});
    this.issues = __WEBPACK_IMPORTED_MODULE_0_vue__["default"].resource(root + '/' + boardId + '/lists{/id}/issues', {}, {
      bulkUpdate: {
        method: 'POST',
        url: bulkUpdatePath
      }
    });
  }

  _createClass(BoardService, [{
    key: 'all',
    value: function all() {
      return this.lists.get();
    }
  }, {
    key: 'generateDefaultLists',
    value: function generateDefaultLists() {
      return this.lists.generate({});
    }
  }, {
    key: 'createList',
    value: function createList(label_id) {
      return this.lists.save({}, {
        list: {
          label_id: label_id
        }
      });
    }
  }, {
    key: 'updateList',
    value: function updateList(id, position) {
      return this.lists.update({ id: id }, {
        list: {
          position: position
        }
      });
    }
  }, {
    key: 'destroyList',
    value: function destroyList(id) {
      return this.lists.delete({ id: id });
    }
  }, {
    key: 'getIssuesForList',
    value: function getIssuesForList(id) {
      var filter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = { id: id };
      Object.keys(filter).forEach(function (key) {
        data[key] = filter[key];
      });

      return this.issues.get(data);
    }
  }, {
    key: 'moveIssue',
    value: function moveIssue(id) {
      var from_list_id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var to_list_id = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var move_before_iid = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
      var move_after_iid = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;

      return this.issue.update({ id: id }, {
        from_list_id: from_list_id,
        to_list_id: to_list_id,
        move_before_iid: move_before_iid,
        move_after_iid: move_after_iid
      });
    }
  }, {
    key: 'newIssue',
    value: function newIssue(id, issue) {
      return this.issues.save({ id: id }, {
        issue: issue
      });
    }
  }, {
    key: 'getBacklog',
    value: function getBacklog(data) {
      return this.boards.issues(data);
    }
  }, {
    key: 'bulkUpdate',
    value: function bulkUpdate(issueIds) {
      var extraData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var data = {
        update: Object.assign(extraData, {
          issuable_ids: issueIds.join(',')
        })
      };

      return this.issues.bulkUpdate(data);
    }
  }]);

  return BoardService;
}();

window.BoardService = BoardService;

/***/ }),

/***/ "./boards/stores/boards_store.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__("../../../node_modules/underscore/underscore.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie__ = __webpack_require__("../../../node_modules/js-cookie/src/js.cookie.js");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_js_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_js_cookie__);
/* eslint-disable comma-dangle, space-before-function-paren, one-var, no-shadow, dot-notation, max-len */
/* global List */



window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

gl.issueBoards.BoardsStore = {
  disabled: false,
  filter: {
    path: ''
  },
  state: {},
  detail: {
    issue: {}
  },
  moving: {
    issue: {},
    list: {}
  },
  create: function create() {
    this.state.lists = [];
    this.filter.path = gl.utils.getUrlParamsArray().join('&');
    this.detail = { issue: {} };
  },
  addList: function addList(listObj, defaultAvatar) {
    var list = new List(listObj, defaultAvatar);
    this.state.lists.push(list);

    return list;
  },
  new: function _new(listObj) {
    var _this = this;

    var list = this.addList(listObj);
    var backlogList = this.findList('type', 'backlog', 'backlog');

    list.save().then(function () {
      // Remove any new issues from the backlog
      // as they will be visible in the new list
      list.issues.forEach(backlogList.removeIssue.bind(backlogList));
      _this.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(_this.state.lists, 'position');
    }).catch(function () {
      // https://gitlab.com/gitlab-org/gitlab-ce/issues/30821
    });
    this.removeBlankState();
  },
  updateNewListDropdown: function updateNewListDropdown(listId) {
    $('.js-board-list-' + listId).removeClass('is-active');
  },
  shouldAddBlankState: function shouldAddBlankState() {
    // Decide whether to add the blank state
    return !this.state.lists.filter(function (list) {
      return list.type !== 'backlog' && list.type !== 'closed';
    })[0];
  },
  addBlankState: function addBlankState() {
    if (!this.shouldAddBlankState() || this.welcomeIsHidden() || this.disabled) return;

    this.addList({
      id: 'blank',
      list_type: 'blank',
      title: 'Welcome to your Issue Board!',
      position: 0
    });

    this.state.lists = __WEBPACK_IMPORTED_MODULE_0_underscore___default.a.sortBy(this.state.lists, 'position');
  },
  removeBlankState: function removeBlankState() {
    this.removeList('blank');

    __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.set('issue_board_welcome_hidden', 'true', {
      expires: 365 * 10,
      path: ''
    });
  },
  welcomeIsHidden: function welcomeIsHidden() {
    return __WEBPACK_IMPORTED_MODULE_1_js_cookie___default.a.get('issue_board_welcome_hidden') === 'true';
  },
  removeList: function removeList(id) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'blank';

    var list = this.findList('id', id, type);

    if (!list) return;

    this.state.lists = this.state.lists.filter(function (list) {
      return list.id !== id;
    });
  },
  moveList: function moveList(listFrom, orderLists) {
    var _this2 = this;

    orderLists.forEach(function (id, i) {
      var list = _this2.findList('id', parseInt(id, 10));

      list.position = i;
    });
    listFrom.update();
  },
  moveIssueToList: function moveIssueToList(listFrom, listTo, issue, newIndex) {
    var issueTo = listTo.findIssue(issue.id);
    var issueLists = issue.getLists();
    var listLabels = issueLists.map(function (listIssue) {
      return listIssue.label;
    });

    if (!issueTo) {
      // Add to new lists issues if it doesn't already exist
      listTo.addIssue(issue, listFrom, newIndex);
    } else {
      listTo.updateIssueLabel(issue, listFrom);
      issueTo.removeLabel(listFrom.label);
    }

    if (listTo.type === 'closed' && listFrom.type !== 'backlog') {
      issueLists.forEach(function (list) {
        list.removeIssue(issue);
      });
      issue.removeLabels(listLabels);
    } else {
      listFrom.removeIssue(issue);
    }
  },
  moveIssueInList: function moveIssueInList(list, issue, oldIndex, newIndex, idArray) {
    var beforeId = parseInt(idArray[newIndex - 1], 10) || null;
    var afterId = parseInt(idArray[newIndex + 1], 10) || null;

    list.moveIssue(issue, oldIndex, newIndex, beforeId, afterId);
  },
  findList: function findList(key, val) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'label';

    return this.state.lists.filter(function (list) {
      var byType = type ? list['type'] === type : true;

      return list[key] === val && byType;
    })[0];
  },
  updateFiltersUrl: function updateFiltersUrl() {
    history.pushState(null, null, '?' + this.filter.path);
  }
};
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__("../../../node_modules/jquery/dist/jquery.js")))

/***/ }),

/***/ "./boards/stores/modal_store.js":
/***/ (function(module, exports) {

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

window.gl = window.gl || {};
window.gl.issueBoards = window.gl.issueBoards || {};

var ModalStore = function () {
  function ModalStore() {
    _classCallCheck(this, ModalStore);

    this.store = {
      columns: 3,
      issues: [],
      issuesCount: false,
      selectedIssues: [],
      showAddIssuesModal: false,
      activeTab: 'all',
      selectedList: null,
      searchTerm: '',
      loading: false,
      loadingNewPage: false,
      filterLoading: false,
      page: 1,
      perPage: 50,
      filter: {
        path: ''
      }
    };
  }

  _createClass(ModalStore, [{
    key: 'selectedCount',
    value: function selectedCount() {
      return this.getSelectedIssues().length;
    }
  }, {
    key: 'toggleIssue',
    value: function toggleIssue(issueObj) {
      var issue = issueObj;
      var selected = issue.selected;

      issue.selected = !selected;

      if (!selected) {
        this.addSelectedIssue(issue);
      } else {
        this.removeSelectedIssue(issue);
      }
    }
  }, {
    key: 'toggleAll',
    value: function toggleAll() {
      var _this = this;

      var select = this.selectedCount() !== this.store.issues.length;

      this.store.issues.forEach(function (issue) {
        var issueUpdate = issue;

        if (issueUpdate.selected !== select) {
          issueUpdate.selected = select;

          if (select) {
            _this.addSelectedIssue(issue);
          } else {
            _this.removeSelectedIssue(issue);
          }
        }
      });
    }
  }, {
    key: 'getSelectedIssues',
    value: function getSelectedIssues() {
      return this.store.selectedIssues.filter(function (issue) {
        return issue.selected;
      });
    }
  }, {
    key: 'addSelectedIssue',
    value: function addSelectedIssue(issue) {
      var index = this.selectedIssueIndex(issue);

      if (index === -1) {
        this.store.selectedIssues.push(issue);
      }
    }
  }, {
    key: 'removeSelectedIssue',
    value: function removeSelectedIssue(issue) {
      var forcePurge = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.store.activeTab === 'all' || forcePurge) {
        this.store.selectedIssues = this.store.selectedIssues.filter(function (fIssue) {
          return fIssue.id !== issue.id;
        });
      }
    }
  }, {
    key: 'purgeUnselectedIssues',
    value: function purgeUnselectedIssues() {
      var _this2 = this;

      this.store.selectedIssues.forEach(function (issue) {
        if (!issue.selected) {
          _this2.removeSelectedIssue(issue, true);
        }
      });
    }
  }, {
    key: 'selectedIssueIndex',
    value: function selectedIssueIndex(issue) {
      return this.store.selectedIssues.indexOf(issue);
    }
  }, {
    key: 'findSelectedIssue',
    value: function findSelectedIssue(issue) {
      return this.store.selectedIssues.filter(function (filteredIssue) {
        return filteredIssue.id === issue.id;
      })[0];
    }
  }]);

  return ModalStore;
}();

gl.issueBoards.ModalStore = new ModalStore();

/***/ }),

/***/ "./boards/utils/query_data.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = (function (path, extraData) {
  return path.split('&').reduce(function (dataParam, filterParam) {
    if (filterParam === '') return dataParam;

    var data = dataParam;
    var paramSplit = filterParam.split('=');
    var paramKeyNormalized = paramSplit[0].replace('[]', '');
    var isArray = paramSplit[0].indexOf('[]');
    var value = decodeURIComponent(paramSplit[1]).replace(/\+/g, ' ');

    if (isArray !== -1) {
      if (!data[paramKeyNormalized]) {
        data[paramKeyNormalized] = [];
      }

      data[paramKeyNormalized].push(value);
    } else {
      data[paramKeyNormalized] = value;
    }

    return data;
  }, extraData);
});

/***/ }),

/***/ "./sidebar/components/assignees/assignee_title.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'AssigneeTitle',
  props: {
    loading: {
      type: Boolean,
      required: false,
      default: false
    },
    numberOfAssignees: {
      type: Number,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    },
    showToggle: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: {
    assigneeTitle: function assigneeTitle() {
      var assignees = this.numberOfAssignees;
      return assignees > 1 ? assignees + ' Assignees' : 'Assignee';
    }
  },
  template: '\n    <div class="title hide-collapsed">\n      {{assigneeTitle}}\n      <i\n        v-if="loading"\n        aria-hidden="true"\n        class="fa fa-spinner fa-spin block-loading"\n      />\n      <a\n        v-if="editable"\n        class="edit-link pull-right"\n        href="#"\n      >\n        Edit\n      </a>\n      <a\n        v-if="showToggle"\n        aria-label="Toggle sidebar"\n        class="gutter-toggle pull-right js-sidebar-toggle"\n        href="#"\n        role="button"\n      >\n        <i\n          aria-hidden="true"\n          data-hidden="true"\n          class="fa fa-angle-double-right"\n        />\n      </a>\n    </div>\n  '
});

/***/ }),

/***/ "./sidebar/components/assignees/assignees.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Assignees',
  data: function data() {
    return {
      defaultRenderCount: 5,
      defaultMaxCounter: 99,
      showLess: true
    };
  },

  props: {
    rootPath: {
      type: String,
      required: true
    },
    users: {
      type: Array,
      required: true
    },
    editable: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    firstUser: function firstUser() {
      return this.users[0];
    },
    hasMoreThanTwoAssignees: function hasMoreThanTwoAssignees() {
      return this.users.length > 2;
    },
    hasMoreThanOneAssignee: function hasMoreThanOneAssignee() {
      return this.users.length > 1;
    },
    hasAssignees: function hasAssignees() {
      return this.users.length > 0;
    },
    hasNoUsers: function hasNoUsers() {
      return !this.users.length;
    },
    hasOneUser: function hasOneUser() {
      return this.users.length === 1;
    },
    renderShowMoreSection: function renderShowMoreSection() {
      return this.users.length > this.defaultRenderCount;
    },
    numberOfHiddenAssignees: function numberOfHiddenAssignees() {
      return this.users.length - this.defaultRenderCount;
    },
    isHiddenAssignees: function isHiddenAssignees() {
      return this.numberOfHiddenAssignees > 0;
    },
    hiddenAssigneesLabel: function hiddenAssigneesLabel() {
      return '+ ' + this.numberOfHiddenAssignees + ' more';
    },
    collapsedTooltipTitle: function collapsedTooltipTitle() {
      var maxRender = Math.min(this.defaultRenderCount, this.users.length);
      var renderUsers = this.users.slice(0, maxRender);
      var names = renderUsers.map(function (u) {
        return u.name;
      });

      if (this.users.length > maxRender) {
        names.push('+ ' + (this.users.length - maxRender) + ' more');
      }

      return names.join(', ');
    },
    sidebarAvatarCounter: function sidebarAvatarCounter() {
      var counter = '+' + (this.users.length - 1);

      if (this.users.length > this.defaultMaxCounter) {
        counter = this.defaultMaxCounter + '+';
      }

      return counter;
    }
  },
  methods: {
    assignSelf: function assignSelf() {
      this.$emit('assign-self');
    },
    toggleShowLess: function toggleShowLess() {
      this.showLess = !this.showLess;
    },
    renderAssignee: function renderAssignee(index) {
      return !this.showLess || index < this.defaultRenderCount && this.showLess;
    },
    avatarUrl: function avatarUrl(user) {
      return user.avatar || user.avatar_url;
    },
    assigneeUrl: function assigneeUrl(user) {
      return '' + this.rootPath + user.username;
    },
    assigneeAlt: function assigneeAlt(user) {
      return user.name + '\'s avatar';
    },
    assigneeUsername: function assigneeUsername(user) {
      return '@' + user.username;
    },
    shouldRenderCollapsedAssignee: function shouldRenderCollapsedAssignee(index) {
      var firstTwo = this.users.length <= 2 && index <= 2;

      return index === 0 || firstTwo;
    }
  },
  template: '\n    <div>\n      <div\n        class="sidebar-collapsed-icon sidebar-collapsed-user"\n        :class="{ \'multiple-users\': hasMoreThanOneAssignee, \'has-tooltip\': hasAssignees }"\n        data-container="body"\n        data-placement="left"\n        :title="collapsedTooltipTitle"\n      >\n        <i\n          v-if="hasNoUsers"\n          aria-label="No Assignee"\n          class="fa fa-user"\n        />\n        <button\n          type="button"\n          class="btn-link"\n          v-for="(user, index) in users"\n          v-if="shouldRenderCollapsedAssignee(index)"\n        >\n          <img\n            width="24"\n            class="avatar avatar-inline s24"\n            :alt="assigneeAlt(user)"\n            :src="avatarUrl(user)"\n          />\n          <span class="author">\n            {{ user.name }}\n          </span>\n        </button>\n        <button\n          v-if="hasMoreThanTwoAssignees"\n          class="btn-link"\n          type="button"\n        >\n          <span\n            class="avatar-counter sidebar-avatar-counter"\n          >\n            {{ sidebarAvatarCounter }}\n          </span>\n        </button>\n      </div>\n      <div class="value hide-collapsed">\n        <template v-if="hasNoUsers">\n          <span class="assign-yourself no-value">\n            No assignee\n            <template v-if="editable">\n             -\n              <button\n                type="button"\n                class="btn-link"\n                @click="assignSelf"\n              >\n                assign yourself\n              </button>\n            </template>\n          </span>\n        </template>\n        <template v-else-if="hasOneUser">\n          <a\n            class="author_link bold"\n            :href="assigneeUrl(firstUser)"\n          >\n            <img\n              width="32"\n              class="avatar avatar-inline s32"\n              :alt="assigneeAlt(firstUser)"\n              :src="avatarUrl(firstUser)"\n            />\n            <span class="author">\n              {{ firstUser.name }}\n            </span>\n            <span class="username">\n              {{ assigneeUsername(firstUser) }}\n            </span>\n          </a>\n        </template>\n        <template v-else>\n          <div class="user-list">\n            <div\n              class="user-item"\n              v-for="(user, index) in users"\n              v-if="renderAssignee(index)"\n            >\n              <a\n                class="user-link has-tooltip"\n                data-placement="bottom"\n                :href="assigneeUrl(user)"\n                :data-title="user.name"\n              >\n                <img\n                  width="32"\n                  class="avatar avatar-inline s32"\n                  :alt="assigneeAlt(user)"\n                  :src="avatarUrl(user)"\n                />\n              </a>\n            </div>\n          </div>\n          <div\n            v-if="renderShowMoreSection"\n            class="user-list-more"\n          >\n            <button\n              type="button"\n              class="btn-link"\n              @click="toggleShowLess"\n            >\n              <template v-if="showLess">\n                {{ hiddenAssigneesLabel }}\n              </template>\n              <template v-else>\n                - show less\n              </template>\n            </button>\n          </div>\n        </template>\n      </div>\n    </div>\n  '
});

/***/ }),

/***/ "./sidebar/event_hub.js":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("../../../node_modules/vue/dist/vue.esm.js");


var eventHub = new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]();

// TODO: remove eventHub hack after code splitting refactor
window.emitSidebarEvent = function () {
  return eventHub.$emit.apply(eventHub, arguments);
};

/* harmony default export */ __webpack_exports__["a"] = (eventHub);

/***/ })

},["./boards/boards_bundle.js"]);


// WEBPACK FOOTER //
// boards.f6a39cae669c8abb7a10.bundle.js